import MaterialBox from "../../../../__snowpack__/pkg/@mui/material/Box.js";
import MaterialDialogActions from "../../../../__snowpack__/pkg/@mui/material/DialogActions.js";
import MaterialDialogTitle from "../../../../__snowpack__/pkg/@mui/material/DialogTitle.js";
import styled from "styled-components";
export const DialogTitleContainer = styled(MaterialDialogTitle).withConfig({
  displayName: "alert-dialogstyles__DialogTitleContainer",
  componentId: "sc-9o6y5v-0"
})(["&&{", " ", "}"], ({
  move
}) => move && {
  cursor: "move"
}, {
  padding: "0px"
});
export const BoxContainer = styled(MaterialBox).withConfig({
  displayName: "alert-dialogstyles__BoxContainer",
  componentId: "sc-9o6y5v-1"
})(["", " ", " ", " & > span{", " ", " ", "}"], {
  display: "flex"
}, {
  alignItems: "center"
}, {
  justifyContent: "space-between"
}, {
  cursor: "pointer"
}, {
  marginLeft: "1rem",
  marginRight: "1rem"
}, {
  marginTop: "1.5rem",
  marginBottom: "1.5rem"
});
export const DialogActionsContainer = styled(MaterialDialogActions).withConfig({
  displayName: "alert-dialogstyles__DialogActionsContainer",
  componentId: "sc-9o6y5v-2"
})(["&&{", "}"], {
  padding: "1rem"
});
